import csBackground from '../../assets/background/IMG_8368.webp';
import HeroBanner, { hexToRgbList } from '../../page_assets/HeroBanner';

// The flat yellow IMG_8368 is printed on, sampled off the photo itself.
export const FIELD = '#f7db00';

// The same yellow the header takes its fill from over this landing — see
// page_assets/header.
export const FIELD_RGB = hexToRgbList(FIELD);

// The moth's own blue. Exported because the header has to pick it up too: this landing
// runs full-bleed up behind the bar, and the accent the bar carries everywhere else is
// this same yellow, which is invisible on the field.
export const INK = '#1519D8';

// The same red the art portfolio's title carries, so the two landings' titles are a pair.
const TITLE_INK = '#E11D2E';

/**
 * The CS portfolio's landing. Everything about how it behaves is HeroBanner's; what's here
 * is this page's own photo, palette and copy.
 *
 * The heading doubles as the page's section nav, so there is no separate row of jump
 * buttons under it.
 *
 * @param sections          [{ id, label }] — the anchors further down the page
 * @param onSelectSection   (id) => void — scrolls to one of them
 */
export default function CSHeroSection({ sections, onSelectSection }) {
    return (
        <HeroBanner
            backgroundImage={csBackground}
            field={FIELD}
            ink={INK}
            titleInk={TITLE_INK}
            title={{ script: 'cs', text: 'Portfolio', syllables: ['por', 'tfo', 'lio'], scriptFirst: true }}
            sections={sections.map((section) => ({
                key: section.id,
                label: section.label,
                onSelect: () => onSelectSection(section.id),
            }))}
            body="My work spans four leading research universities, where I have studied human
                behavior modeling, computational cognitive psychology, and natural language
                processing."
        />
    );
}
